import React from "react";
import list from "javascriptstuff-db/static-site-generators";

import Page from "../../components/common/Page";
import ListPageContainer from "../../components/list/ListPageContainer";
import addNotes from "../../logic/addNotes";
import StyledTextBlock from "../../components/common/StyledTextBlock";
import Link from "../../components/common/Link";

const extendedList = addNotes(list, {
  "gatsbyjs/gatsby": (
    <StyledTextBlock>
      If you use gatsby, check out the list of{` `}
      <Link to="/react-starter-projects#tag:gatsby">
        gatsby starter projects.
      </Link>
    </StyledTextBlock>
  )
});

export default () => (
  <Page>
    <ListPageContainer list={extendedList}>
      <StyledTextBlock>
        <p>
          A <i>static site</i> is one that serves a set of static files in
          response to web requests. The term "static" can seem like a misnomer
          on sites that use frontend JavaScript to create a high level of
          interactivity.
        </p>
        <p>
          You could make a static site by writing every HTML, JavaScript, and
          CSS file from scratch, but these static site generators make the job a
          lot faster, easier, and more fun.
        </p>
      </StyledTextBlock>
    </ListPageContainer>
  </Page>
);



// WEBPACK FOOTER //
// ./src/pages/list/static-site-generators.js